var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinancial(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#0073c2",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.09874,-0.02058) scale(2,2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,128) scale(0.1,-0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M763,1226c-35,-7 -66,-15 -69,-18c-3,-4 0,-16 6,-28c11,-21 5,-30 -76,-111c-49,-49 -92,-89 -97,-89c-8,0 -14,14 -41,91c-16,45 -45,69 -83,69c-19,0 -283,-258 -283,-277c0,-9 17,-13 57,-13h58l82,82c55,55 84,77 87,67c2,-8 10,-31 16,-52c14,-46 59,-77 109,-77c30,0 48,13 146,111c67,65 116,106 119,100c4,-6 15,-11 25,-11c14,0 20,14 29,64c17,88 16,106 -5,105c-10,-1 -46,-6 -80,-13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720,705c0,-80 2,-145 5,-145c2,0 25,10 50,22l45,22v123v123h-50h-50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,534v-195l37,3c33,3 38,7 47,38c5,19 11,106 13,193l4,157h-51h-50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,490v-150h50h50v150v150h-50h-50z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823,566c-131,-43 -201,-146 -190,-282c17,-218 270,-320 437,-177c90,77 117,215 64,321c-56,114 -196,176 -311,138zM1011,503c116,-63 151,-203 79,-316c-80,-127 -263,-137 -359,-20c-56,68 -66,155 -27,239c39,83 102,122 200,123c45,1 69,-5 107,-26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842,489c-49,-15 -107,-78 -120,-132c-39,-154 109,-283 255,-222c74,31 113,92 113,178c0,125 -124,214 -248,176zM917,430c3,-11 14,-20 25,-20c13,0 18,-6 16,-17c-2,-13 -15,-19 -46,-21c-33,-2 -42,-7 -42,-21c0,-14 10,-20 40,-25c50,-8 75,-41 61,-79c-5,-14 -19,-28 -30,-32c-12,-3 -21,-15 -21,-26c0,-25 -30,-25 -37,0c-3,11 -14,22 -26,25c-32,8 -10,24 38,28c32,2 40,7 40,23c0,15 -9,21 -39,26c-69,11 -85,59 -36,109c17,17 30,35 30,40c0,18 22,10 27,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,410v-70h45h45v70v70h-45h-45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,210c0,-19 7,-20 200,-20c193,0 200,1 200,20c0,19 -7,20 -200,20c-193,0 -200,-1 -200,-20z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/financial.ac1ed6bea4911ebfecd4f4ac4483a01a.svg";
export { ForwardRef as ReactComponent };